import { createSlice } from '@reduxjs/toolkit';

import { logout } from 'redux/auth/actions';

import {
    setRateLimitLastRequestTime,
    setCommentLikeRateLimitLastRequestTime,
    setLastConnectionErrorTime,
} from './actions';

export interface RateLimitState {
    lastRequestTime?: number;
    commentLikeLastRequestTime?: number;
    lastConnectionErrorTime?: number;
}

const initialState: RateLimitState = {
    lastRequestTime: undefined,
    commentLikeLastRequestTime: undefined,
    lastConnectionErrorTime: undefined,
};

const rateLimitSlice = createSlice({
    name: 'rateLimit',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });

        builder.addCase(setRateLimitLastRequestTime, (state, { payload: lastRequestTime }) => {
            state.lastRequestTime = lastRequestTime;
        });

        builder.addCase(setCommentLikeRateLimitLastRequestTime, (state, { payload: lastRequestTime }) => {
            state.commentLikeLastRequestTime = lastRequestTime;
        });
        builder.addCase(setLastConnectionErrorTime, (state, { payload: lastConnectionErrorTime }) => {
            state.lastConnectionErrorTime = lastConnectionErrorTime;
        });
    },
});

export default rateLimitSlice.reducer;
